module.exports = __webpack_public_path__ + "prod/1.42.2/img/saas-ai.7c61d485.png";